<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 96.000000 96.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path d="M180 765 l0 -106 30 16 c28 15 30 19 30 75 l0 60 150 0 150 0 0 -90
      0 -90 90 0 90 0 0 -165 0 -165 30 0 30 0 0 188 0 187 -98 98 -97 97 -203 0
      -202 0 0 -105z m460 -40 l34 -35 -37 0 c-36 0 -37 1 -37 35 0 19 1 35 3 35 2
      0 18 -16 37 -35z"/>
      <path d="M213 606 l-28 -24 -3 -172 -3 -172 46 -70 47 -70 44 66 44 65 0 171
      0 172 -29 29 c-37 36 -79 38 -118 5z m84 -201 c2 -129 0 -164 -12 -179 -15
      -20 -15 -20 -30 0 -11 15 -14 54 -15 175 0 86 3 159 7 163 4 4 16 6 28 4 19
      -3 20 -10 22 -163z"/>
      <path d="M693 221 c-17 -20 -45 -44 -62 -54 l-31 -18 0 25 c0 31 -32 66 -60
      66 -26 0 -73 -24 -126 -65 -42 -31 -42 -31 -24 -55 l18 -23 48 35 c69 49 84
      53 84 23 0 -31 33 -65 63 -65 12 0 34 7 47 16 31 21 120 106 120 115 0 4 -10
      13 -22 21 -21 13 -25 12 -55 -21z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
